import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import z from "zod";
import { assetQueryOptions } from "@/services/asset/asset.options";
import { OrgAssetTypeFullIndexTabContent } from "./full";

const FULL_INDEX =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: OrgAssetTypeFullIndexRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; assetTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				assetTypeId: z.string().parse(p.assetTypeId),
			};
		},
	},
});

function OrgAssetTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		assetQueryOptions.typeDetail(params.assetTypeId, {
			organizationId: params.orgId,
		}),
	);

	const assetType = detailQuery.data ?? null;

	if (!assetType) {
		return null;
	}

	return (
		<OrgAssetTypeFullIndexTabContent
			tab={search.tab}
			assetType={assetType}
			orgId={params.orgId}
		/>
	);
}
